module.exports = __webpack_public_path__ + "img/AICM智能会员管理系统.537e3001.png";